import type { IconNode } from '../types';

/**
 * @name penguin
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuOSAxNWE1Ljg3IDUuODcgMCAwIDAtMS43LTMuM2wtLjItLjJjLS42LS42LTEtMS41LTEtMi41VjVhMyAzIDAgMSAwLTYgMHY0YTMuNzQgMy43NCAwIDAgMS0xLjIgMi44IDYuMiA2LjIgMCAwIDAtMS43IDMuMyIgLz4KICA8cGF0aCBkPSJNOSAxMGMtMiA0LTQtMS03IDIiIC8+CiAgPHBhdGggZD0iTTkgOC45YzMtMS45IDYgMCA2IDBzLTIgMy4xLTMgNGMtMS0uOS0zLTQtMy00IiAvPgogIDxwYXRoIGQ9Ik0xNSAxMGMyIDQgNC0xIDcgMiIgLz4KICA8cGF0aCBkPSJNMiAxOWMwLTEgMS0xIDEtMiAwLS42LjQtMSAxLTEgMSAwIDEtMSAyLTEgLjQgMCAuNy4yLjkuNUw4LjggMTlhMiAyIDAgMCAxLTIuNyAyLjdsLTMuNS0xLjljLS40LS4xLS42LS40LS42LS44IiAvPgogIDxwYXRoIGQ9Ik04LjcgMjFhNi4wNyA2LjA3IDAgMCAwIDYuNiAwIiAvPgogIDxwYXRoIGQ9Ik0yMiAxOWMwLTEtMS0xLTEtMiAwLS42LS40LTEtMS0xLTEgMC0xLTEtMi0xLS40IDAtLjcuMi0uOS41TDE1LjIgMTlhMiAyIDAgMCAwIDIuNyAyLjdsMy41LTEuOWMuNC0uMS42LS40LjYtLjgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/penguin
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const penguin: IconNode = [
  [
    'path',
    {
      d: 'M17.9 15a5.87 5.87 0 0 0-1.7-3.3l-.2-.2c-.6-.6-1-1.5-1-2.5V5a3 3 0 1 0-6 0v4a3.74 3.74 0 0 1-1.2 2.8 6.2 6.2 0 0 0-1.7 3.3',
      key: 'aeweh8',
    },
  ],
  ['path', { d: 'M9 10c-2 4-4-1-7 2', key: '1i5awj' }],
  ['path', { d: 'M9 8.9c3-1.9 6 0 6 0s-2 3.1-3 4c-1-.9-3-4-3-4', key: '1cijth' }],
  ['path', { d: 'M15 10c2 4 4-1 7 2', key: '1dohmu' }],
  [
    'path',
    {
      d: 'M2 19c0-1 1-1 1-2 0-.6.4-1 1-1 1 0 1-1 2-1 .4 0 .7.2.9.5L8.8 19a2 2 0 0 1-2.7 2.7l-3.5-1.9c-.4-.1-.6-.4-.6-.8',
      key: '150xc0',
    },
  ],
  ['path', { d: 'M8.7 21a6.07 6.07 0 0 0 6.6 0', key: 'k6k4be' }],
  [
    'path',
    {
      d: 'M22 19c0-1-1-1-1-2 0-.6-.4-1-1-1-1 0-1-1-2-1-.4 0-.7.2-.9.5L15.2 19a2 2 0 0 0 2.7 2.7l3.5-1.9c.4-.1.6-.4.6-.8',
      key: '1yj2bp',
    },
  ],
];

export default penguin;
